module.exports = __webpack_public_path__ + "static/media/logoShadow.2dde5cc3.svg";